var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReporticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8232 3.64317C12.5218 3.34192 12 3.54765 12 3.96647V6.53082C12 7.60358 12.9114 8.49265 14.0211 8.49265C14.7194 8.5 15.6895 8.5 16.52 8.5C16.9389 8.5 17.1594 8.0077 16.8654 7.7138C15.8071 6.64838 13.9109 4.73063 12.8232 3.64317Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3158 9.233H14.3384C12.7168 9.233 11.3963 7.882 11.3963 6.223V4.2C11.3963 3.815 11.0884 3.5 10.7121 3.5H7.81105C5.70368 3.5 4 4.9 4 7.399V13.601C4 16.1 5.70368 17.5 7.81105 17.5H13.1889C15.2963 17.5 17 16.1 17 13.601V9.933C17 9.548 16.6921 9.233 16.3158 9.233ZM10.1579 14.525H7.42105C7.14053 14.525 6.90789 14.287 6.90789 14C6.90789 13.713 7.14053 13.475 7.42105 13.475H10.1579C10.4384 13.475 10.6711 13.713 10.6711 14C10.6711 14.287 10.4384 14.525 10.1579 14.525ZM11.5263 11.725H7.42105C7.14053 11.725 6.90789 11.487 6.90789 11.2C6.90789 10.913 7.14053 10.675 7.42105 10.675H11.5263C11.8068 10.675 12.0395 10.913 12.0395 11.2C12.0395 11.487 11.8068 11.725 11.5263 11.725Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporticon);
export default __webpack_public_path__ + "static/media/reporticon.bfd90272b12844b23c45ec5ee3e44bda.svg";
export { ForwardRef as ReactComponent };